import {
  GET_CATALOG_ITEMS,
  GET_CATALOG_ITEMS_SUCCESS,
  GET_CATALOG_ITEMS_FAIL,
  ADD_CATALOG_ITEM,
  ADD_CATALOG_ITEM_SUCCESS,
  ADD_CATALOG_ITEM_FAIL,
  UPDATE_CATALOG_ITEM,
  UPDATE_CATALOG_ITEM_SUCCESS,
  UPDATE_CATALOG_ITEM_FAIL,
  DELETE_CATALOG_ITEM,
  DELETE_CATALOG_ITEM_SUCCESS,
  DELETE_CATALOG_ITEM_FAIL,
  SET_FIELD_ERRORS,
} from './actionTypes'

// Get Catalog Items
export const getCatalogItems = (id) => ({
  type: GET_CATALOG_ITEMS,
  payload: {id}
})

export const getCatalogItemsSuccess = (items) => ({
  type: GET_CATALOG_ITEMS_SUCCESS,
  payload: items,
})

export const getCatalogItemsFail = (error) => ({
  type: GET_CATALOG_ITEMS_FAIL,
  payload: error,
})

// Add Catalog Item
export const addCatalogItem = (item, navigate, resetForm) => ({
  type: ADD_CATALOG_ITEM,
  payload: { item, navigate, resetForm },
})

export const addCatalogItemSuccess = (item) => ({
  type: ADD_CATALOG_ITEM_SUCCESS,
  payload: item,
})

export const addCatalogItemFail = (error) => ({
  type: ADD_CATALOG_ITEM_FAIL,
  payload: error,
})

// Update Catalog Item
export const updateCatalogItem = (item, navigate) => ({
  type: UPDATE_CATALOG_ITEM,
  payload: { item, navigate },
})

export const updateCatalogItemSuccess = (item) => ({
  type: UPDATE_CATALOG_ITEM_SUCCESS,
  payload: item,
})

export const updateCatalogItemFail = (error) => ({
  type: UPDATE_CATALOG_ITEM_FAIL,
  payload: error,
})

// Delete Catalog Item
export const deleteCatalogItem = (id) => ({
  type: DELETE_CATALOG_ITEM,
  payload: id,
})

export const deleteCatalogItemSuccess = (id) => ({
  type: DELETE_CATALOG_ITEM_SUCCESS,
  payload: id,
})

export const deleteCatalogItemFail = (error) => ({
  type: DELETE_CATALOG_ITEM_FAIL,
  payload: error,
})

// Set Field Errors
export const setFieldErrors = (errors) => ({
  type: SET_FIELD_ERRORS,
  payload: errors,
})
